<div
  class="h-full min-h-0 flex flex-col gap-2 overflow-y-auto bg-neutral-10 scrollbar p-2 pb-20"
>
  <maximizer-outlook-entry-search
    [entryActions]="buildEntryActions"
    (searchActiveChange)="searchActive.set($event)"
  ></maximizer-outlook-entry-search>

  @if (!searchActive()) {
    @if (calendarStore.isLoading()) {
      <div class="bg-white rounded p-3">
        <maximizer-outlook-skeleton-attendee-item></maximizer-outlook-skeleton-attendee-item>
        <maximizer-outlook-skeleton-attendee-item></maximizer-outlook-skeleton-attendee-item>
        <maximizer-outlook-skeleton-attendee-item></maximizer-outlook-skeleton-attendee-item>
      </div>
    } @else {
      <div class="bg-white rounded p-3 flex flex-col gap-1">
        <div class="flex justify-between items-center mb-1">
          <p class="subtitle-2">
            {{ 'outlook.calendar.compose.attendees' | translate }} ({{
              calendarStore.inMaximizerAttendees().length
            }})
          </p>
          <div class="flex items-center gap-2">
            @if (outlookStore.saveAppointmentShown()) {
              <span
                kendoTooltip
                title="{{ saveAppointmentTooltipKey() | translate }}"
                [tooltipWidth]="saveAppointmentTooltipWidth()"
                [tooltipTemplate]="saveTooltip"
                [callout]="false"
                class="inline-flex"
              >
                <button
                  id="outlook-main-ui-calendarRead-saveAppointment"
                  kendoButton
                  themeColor="primary"
                  [disabled]="saveAppointmentDisabledReason() !== 'none'"
                  (click)="onSaveAppointment()"
                  class="text-body bold h-7"
                  [iconClass]="saveAppointmentIconClass()"
                >
                  {{
                    saveAppointmentLabelKey()
                      | translate: saveAppointmentLabelParams()
                  }}
                </button>
              </span>
            }
          </div>
        </div>

        @if (!calendarStore.hasAttendees()) {
          <p class="text-body text-neutral-90 text-pretty px-3 py-2">
            {{ 'outlook.calendar.read.noAttendees' | translate }}
          </p>
        } @else if (calendarStore.inMaximizerAttendees().length === 0) {
          <p class="text-body text-neutral-90 text-pretty px-3 py-2">
            {{ 'outlook.calendar.noAttendees' | translate }}
          </p>
        }

        @if (calendarStore.requiredAttendees().length > 0) {
          <p class="subtitle-2 text-neutral-90">
            {{ 'outlook.calendar.compose.required' | translate }}:
          </p>
          @for (
            attendee of calendarStore.requiredAttendees();
            track attendee.emailAddress
          ) {
            <maximizer-outlook-calendar-attendee-item
              [attendee]="attendee"
              [userEmails]="outlookStore.userEmails()"
              mode="read"
              (navigate)="onNavigate($event)"
              (addEntry)="onAddEntry($event)"
              (notify)="onNotify($event)"
            ></maximizer-outlook-calendar-attendee-item>
          }
        }

        @if (calendarStore.optionalAttendees().length > 0) {
          <p class="subtitle-2 text-neutral-90">
            {{ 'outlook.calendar.compose.optional' | translate }}:
          </p>
          @for (
            attendee of calendarStore.optionalAttendees();
            track attendee.emailAddress
          ) {
            <maximizer-outlook-calendar-attendee-item
              [attendee]="attendee"
              [userEmails]="outlookStore.userEmails()"
              mode="read"
              (navigate)="onNavigate($event)"
              (addEntry)="onAddEntry($event)"
              (notify)="onNotify($event)"
            ></maximizer-outlook-calendar-attendee-item>
          }
        }
      </div>

      @if (calendarStore.notInMaximizerAttendees().length > 0) {
        <maximizer-outlook-calendar-not-in-maximizer-list
          [attendees]="calendarStore.notInMaximizerAttendees()"
          [userEmails]="outlookStore.userEmails()"
          mode="read"
          (navigate)="onNavigate($event)"
          (addEntry)="onAddEntry($event)"
          (notify)="onNotify($event)"
        ></maximizer-outlook-calendar-not-in-maximizer-list>
      }
    }
  }
</div>

<maximizer-outlook-notification
  #notification
  [closable]="true"
></maximizer-outlook-notification>

@if (appointmentPrefill()) {
  <kendo-dialog
    width="100%"
    height="100%"
    maxWidth="500px"
    (close)="onAppointmentFormCancelled()"
  >
    <div
      class="reset flex items-center justify-between bg-neutral-10 px-2 py-1"
    >
      <p class="subtitle-1 text-black">
        {{ 'outlook.appointment.addTitle' | translate }}
      </p>
      <button
        kendoButton
        themeColor="tertiary"
        iconClass="fa-icons icon-xmark icon-14"
        [attr.aria-label]="'outlook.buttons.close' | translate"
        class="small"
        [disabled]="savingAppointment()"
        (click)="onAppointmentFormCancelled()"
      ></button>
    </div>
    <maximizer-add-appointment
      class="embedded-form flex flex-col flex-1 min-h-0"
      [embedded]="true"
      [prefill]="appointmentPrefill()"
      (saved)="onAppointmentFormSaved($event)"
      (partiallySaved)="onAppointmentFormPartiallySaved($event)"
      (savingChange)="onAppointmentFormSavingChange($event)"
      (cancelled)="onAppointmentFormCancelled()"
    ></maximizer-add-appointment>
  </kendo-dialog>
}

<ng-template #saveTooltip>
  <p class="caption text-center text-neutral-90">
    {{ saveAppointmentTooltipKey() | translate }}
  </p>
</ng-template>
